<template>
  <div id="app">
    <NuxtLayout>
      <main>
        <NuxtPage />
      </main>
    </NuxtLayout>
  </div>
</template>

<script setup></script>
